<template>
  <panel :url="url"
         :bg-url="bgUrl"
         :bg-url2="bgUrl2"
         :content="content"
         bg-align="left-bottom"
         bg-align2="right-top"
         section="社媒引流"></panel>
</template>

<script>
import panel from './panel-2'

export default {
  components: {
    panel,
  },
  data () {
    return {
      url: require('@/assets/access_images/access-facebook-ads.png'),
      bgUrl: require('@/assets/access_images/access-facebook-ads_bg1.png'),
      bgUrl2: require('@/assets/access_images/access-facebook-ads_bg2.png'),
      content: [
        '除了搜索广告',
        '信息流的赛道Facebook Ads智能投放为你领航'
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
</style>